import {
  CheckCircle2,
  Users2,
  Share2,
  TrendingUp,
  Target,
  Zap,
  Sliders,
  Database,
  Search,
  FileCheck2,
  Network,
  ShieldCheck,
} from "lucide-react";

export const HERO_HIGHLIGHT_STEPS = [
  {
    step: "01",
    title: "Validate",
    desc: "Verify accuracy, syntax, and deliverability before importing.",
    icon: CheckCircle2,
  },
  {
    step: "02",
    title: "Connect",
    desc: "Reach receptive corporate target groups with verified purchase intent.",
    icon: Users2,
  },
  {
    step: "03",
    title: "Network",
    desc: "Strengthen global brand presence with negligible bounce rates.",
    icon: Share2,
  },
];

export const VALIDATION_REASONS = [
  {
    icon: Zap,
    title: "Real-Time Data Validation to Advance Conversion",
    desc: "Instantaneous validation routines that eliminate lead drop-off and accelerate sales velocity.",
  },
  {
    icon: Share2,
    title: "Quality Data for Multichannel Statement",
    desc: "Synchronized email, phone, and firmographic records prepared for omni-channel campaigns.",
  },
  {
    icon: TrendingUp,
    title: "Expand Open Rates & Re-engage Customers",
    desc: "Protect sender reputation, maximize inbox delivery, and activate dormant accounts.",
  },
  {
    icon: Target,
    title: "Make Well-Versed Business Decisions",
    desc: "Rely on verified, authenticated market insights rather than unvetted assumptions.",
  },
  {
    icon: CheckCircle2,
    title: "Increase Assignation & Conversions",
    desc: "Empower account executives to contact confirmed buyers ready for commercial engagement.",
  },
  {
    icon: Sliders,
    title: "Simple Workflow Management",
    desc: "Frictionless integration into major CRM and sales acceleration stacks without data decay.",
  },
];

export const VALIDATION_CYCLE = [
  {
    id: "pattern",
    step: "01",
    title: "Determination of the Data Pattern",
    icon: Search,
    desc: "The first step in the data validation process is to enter the data and identify the correct validation tool to run. Our experts validate a variety of data to verify the error rate and create a timeline for the entire validation process.",
  },
  {
    id: "format",
    step: "02",
    title: "Validate and Format the Database",
    icon: FileCheck2,
    desc: "Syntactic structure, MX records, domain integrity, and missing value entries are scrubbed, formatted, and standardized across international protocols.",
  },
  {
    id: "multichannel",
    step: "03",
    title: "Multi-Channel Validation",
    icon: Network,
    desc: "Cross-referencing contact points across human intelligence checks, SMTP handshakes, and public business registers to guarantee 100% receptiveness.",
  },
  {
    id: "authentic",
    step: "04",
    title: "Authentic Database",
    icon: ShieldCheck,
    desc: "Final output delivered error-free, free of duplicate records, and fully verified for instant deployment into sales and marketing pipelines.",
  },
];

// Highlight metrics incorporating the Database icon
export const VALIDATION_STATS = [
  {
    icon: Database,
    label: "Clean Database Records",
    value: "100%",
  },
  {
    icon: ShieldCheck,
    label: "Delivery Assurance",
    value: "99%+",
  },
];